module.exports = __webpack_public_path__ + "static/media/feature-analytics.65a69dd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/feature-analytics.svg
// module id = 13910
// module chunks = 0